module.exports = __webpack_public_path__ + "img/MTCILBMA.bcf8a4f0.png";